import { GDPR_CONSENT_COMPLIANCE_FLAG } from '@borradh-workspace/labels';
import { useFeatureFlagEnabled } from 'posthog-js/react';
export function useGdprConsentCompliance(): boolean {
  return useFeatureFlagEnabled(GDPR_CONSENT_COMPLIANCE_FLAG) === true;
}
